import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Button from 'components/base/Button';
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ForgotPasswordForm = ({
  layout
}: {
  layout?: 'simple' | 'card' | 'split';
}) => {
  return (
    <div className={classNames({ 'px-xxl-5': !(layout === 'split') })}>
      <div
        className={classNames('text-center', { 'mb-6': !(layout === 'split') })}
      >
        <h4 className="text-1000">Esqueceu a sua senha?</h4>
        <p className="text-700 mb-5">
          Digite seu e-mail abaixo e nós enviaremos <br className="d-sm-none" />
          um link de redefinição
        </p>
        <Form className="d-flex align-items-center mb-5">
          <Form.Control
            type="email"
            id="email"
            className="flex-1"
            placeholder="Email"
          />
          <Button
            variant="primary"
            className="ms-2"
            endIcon={<FontAwesomeIcon icon={faChevronRight} className="ms-2" />}
          >
            Enviar
          </Button>
        </Form>
        <Link to="#!" className="fs-9 fw-bold">
          Ainda tendo problemas?
        </Link>
        <br />
        <Link to={`/`} className="fs-9 fw-bold">
          Entrar no sistema
        </Link>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
